import BrandImagePanel from './brandImagePanel.container'

export default BrandImagePanel;
